import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import routes from 'constants/routes';
import { RootState } from 'store';
import { isSuperAdmin } from 'features/auth/helpers';
import { Layout } from 'features/common/components/Layout';
import { McpUsersManagement } from 'features/mcpConnector/components/McpUsersManagement';

/**
 * "Conector de datos (Claude)", en Administración. Como el menú, solo para Super Admin: el resto vuelve al inicio (la
 * API igual rechaza a cualquier otro rol).
 */
export const McpConnectorUsersPage = (): JSX.Element => {
	const user = useSelector((state: RootState) => state.auth.user);
	if (!isSuperAdmin(user)) {
		return <Redirect to={routes.home} />;
	}
	return (
		<Layout>
			<Grid container paddingY={5} paddingX={3} spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h4" style={{ fontWeight: 500 }}>
						Conector de datos (Claude)
					</Typography>
					<Typography variant="body2" color="text.secondary">
						Quién puede conectar Claude a los datos de mevuelo, qué áreas ve y si ve costos, márgenes y proveedores. El
						conector es de solo lectura.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<McpUsersManagement />
				</Grid>
			</Grid>
		</Layout>
	);
};
